import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../redux/store";
import { billActions } from "../redux/bill/bill.slice";
import { Button } from "./Button";
import { billSliceSelectors } from "../redux/bill/bill.selector";
import { Bill } from "../model/bill/types/Bill";
import { AtiraToast } from "../utils/AtiraToast";

type DeleteModalProps = {
  open: boolean;
  onClose: VoidFunction;
  bill?: Bill | null;
};

export const DeleteModal: React.FC<DeleteModalProps> = ({
  open = false,
  onClose,
  bill,
}) => {
  const [loading, setLoading] = useState(false);

  const billsPage = useAppSelector(billSliceSelectors.selectBillsTablePage);
  const billsPageSize = useAppSelector(
    billSliceSelectors.selectBillsTablePageSize
  );

  const dispatch = useAppDispatch();

  const onDelete = async () => {
    try {
      setLoading(true);

      await dispatch(billActions.deleteBill({ billId: bill?._id! })).unwrap();
      await dispatch(
        billActions.getLatestBills({
          meta: {
            count: billsPageSize,
            page: billsPage - 1,
          },
        })
      ).unwrap();
      onClose();

      AtiraToast.success("Bill deleted successfully");
    } catch (e: any) {
      console.log(e);
      AtiraToast.apiError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={open} onHide={onClose}>
      <Modal.Header closeButton style={{ justifyContent: "space-between" }}>
        <Modal.Title>Delete Bill</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="w-100 d-flex flex-column align-items-center gap-4 py-3 px-4">
          <h2 className="text-center">Delete bill {bill?.billNumber}?</h2>

          <p className="fs-5 text-center text-muted">
            Once you delete this bill, it cannot be recovered later. This action
            cannot be undone
          </p>

          <div className="d-flex gap-2 mt-5">
            <Button
              onClick={onClose}
              className="create-bill-btn btn btn-primary py-1 px-3 rounded-2 me-auto d-flex align-items-center justify-content-center"
            >
              Cancel
            </Button>
            <Button
              onClick={onDelete}
              className="create-bill-btn btn btn-danger py-1 px-3 rounded-2 me-auto d-flex align-items-center justify-content-center"
              loading={loading}
            >
              Delete
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
